import Vue from 'vue'
import Router from 'vue-router'
import { stringifyQuery, parseQuery } from './utils/query'
import { getToken, setToken } from '@/utils/auth'
import { isIOS, initWechatSDK, iosInitWechatSDK } from '@/utils/wxShare'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: '/',
      redirect: '/home',
      component: () => import('@/views/index'),
      children: [
        {
          path: '/home',
          meta: {
            title: '首页'
          },
          component: () => import('@/views/home')
        },
        {
          path: '/buyCourse',
          meta: {
            title: '已购课程',
            isAuth: true
          },
          component: () => import('@/views/buyCourse')
        },
        {
          path: '/my',
          meta: {
            title: '我的',
            isAuth: true
          },
          component: () => import('@/views/my')
        }
      ]
    },
    {
      path: '/coursePageInfo',
      component: () => import('@/views/coursePageInfo'),
      meta: {
        title: '课程管理',
        isAuth: true
      }
    },
    {
      path: '/coursePage',
      component: () => import('@/views/coursePage'),
      meta: {
        title: '课程管理',
        isAuth: true
      }
    },
    {
      path: '/activity',
      component: () => import('@/views/activity'),
      meta: {
        title: '讲师主页',
        isAuth: true
      }
    },
    {
      path: '/evaluate',
      component: () => import('@/views/evaluate'),
      meta: {
        title: '评价',
        isAuth: true
      }
    },
    {
      path: '/evaluateMore',
      component: () => import('@/views/evaluateMore'),
      meta: {
        title: '评价中心',
        isAuth: true
      }
    },
    {
      path: '/studyVideo',
      component: () => import('@/views/studyVideo'),
      meta: {
        title: '学习中心',
        isAuth: true
      }
    },
    {
      path: '/studyAudio',
      component: () => import('@/views/studyAudio'),
      meta: {
        title: '学习中心',
        isAuth: true
      }
    },
    {
      path: '/studyImgTxt',
      component: () => import('@/views/studyImgTxt'),
      meta: {
        title: '学习中心',
        isAuth: true
      }
    },
    {
      path: '/search',
      component: () => import('@/views/search'),
      meta: {
        title: '搜索',
        isAuth: true
      }
    },
    {
      path: '/catelog',
      component: () => import('@/views/catelog'),
      meta: {
        title: '分类',
        isAuth: true
      }
    },
    {
      path: '/preferredCourse',
      component: () => import('@/views/preferredCourse'),
      meta: {
        title: '优选好课',
        isAuth: true
      }
    },

    {
      path: '/discountZone',
      component: () => import('@/views/discountZone'),
      meta: {
        title: '优惠专区',
        isAuth: true
      }
    },
    {
      path: '/seckillPage',
      component: () => import('@/views/seckillPage'),
      meta: {
        title: '秒杀专区',
        isAuth: true
      }
    },
    {
      path: '/order',
      component: () => import('@/views/order'),
      meta: {
        title: '订单管理',
        isAuth: true
      }
    },
    {
      path: '/orderDetail',
      component: () => import('@/views/orderDetail'),
      meta: {
        title: '订单详情',
        isAuth: true
      }
    },
    {
      path: '/refundOrder',
      component: () => import('@/views/refundOrder'),
      meta: {
        title: '申请退款',
        isAuth: true
      }
    },
    {
      path: '/refundOrderDetail',
      component: () => import('@/views/refundOrderDetail'),
      meta: {
        title: '退款进度',
        isAuth: true
      }
    },
    {
      path: '/login',
      component: () => import('@/views/login'),
      meta: {
        title: '登录'
      }
    },

    {
      path: '/bindPhone',
      component: () => import('@/views/bindPhone'),
      meta: {
        title: '绑定手机号',
        isAuth: true
      }
    },
    {
      path: '/realName',
      component: () => import('@/views/realName'),
      meta: {
        title: '实名认证'
      }
    },
    {
      path: '/address',
      component: () => import('@/views/address'),
      meta: {
        title: '地址管理',
        isAuth: true
      }
    },
    {
      path: '/addAddress',
      component: () => import('@/views/addAddress'),
      meta: {
        title: '添加地址',
        isAuth: true
      }
    },
    {
      path: '/apply',
      component: () => import('@/views/apply'),
      meta: {
        title: '申请入驻',
        isAuth: true
      }
    },
    {
      path: '/aboutUs',
      component: () => import('@/views/aboutUs'),
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/license',
      component: () => import('@/views/license'),
      meta: {
        title: '海洋知道'
      }
    },
    {
      path: '/confirmOrder',
      component: () => import('@/views/confirmOrder'),
      meta: {
        title: '支付'
      }
    },
    {
      path: '/paySuccess',
      component: () => import('@/views/paySuccess'),
      meta: {
        title: '支付成功'
      }
    },
    {
      path: '/protocol',
      component: () => import('@/views/protocol'),
      meta: {
        title: '资质证照公示'
      }
    },
    {
      path: '/sharePoster',
      component: () => import('@/views/sharePoster'),
      meta: {
        title: '分享海报'
      }
    },
    {
      path: '/flow',
      component: () => import('@/views/flow'),
      meta: {
        title: '入驻流程'
      }
    },
    {
      path: '/guidePage',
      component: () => import('@/views/guidePage'),
      meta: {
        title: '海洋知道课堂'
      }
    },
    {
      path: '/transferPage',
      component: () => import('@/views/transferPage'),
      meta: {
        title: '海洋知道课堂'
      }
    },
    {
      path: '/livePay',
      component: () => import('@/views/livePay'),
      meta: {
        title: '支付'
      }
    },
    {
      path: '/liveCoursePay',
      component: () => import('@/views/liveCoursePay'),
      meta: {
        title: '支付'
      }
    }
  ],
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 })
  /*   stringifyQuery: stringifyQuery, // 序列化query参数
  parseQuery: parseQuery */
})
// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err)
}

router.beforeEach((to, from, next) => {
  /*  setToken('') */
  if (!sessionStorage.getItem('url') || from.path == '/') {
    sessionStorage.setItem('url', location.href)
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let token = getToken()
  if (!token) {
    if (to.meta.isAuth) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    if (to.path === '/login') {
      // if (to.query.courseId) {
      //   next({
      //     path: '/coursePage',
      //     query: {
      //       courseId: to.query.courseId
      //     }
      //   })
      // }
      next('/')
    } else {
      next()
    }
  }
})
router.afterEach((to, from) => {
  let url = router.resolve(to.fullPath).href
  if (!url.startsWith('http')) {
    url = window.location.origin + url
  }
  Vue.nextTick(() => {
    if (to.path != '/coursePage' && !isIOS()) {
      initWechatSDK()
    } else if (isIOS() && to.path != '/coursePage') {
      iosInitWechatSDK(url)
    }
  })
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js